






import { Component, Vue } from "vue-property-decorator";
import { getQueryParam } from "@/utils/index";
import PageResult from "@/components/PageResult.vue";
import {formatMessage} from "@/locale"

@Component({
    components: {
        "v-page-result": PageResult
    }
})
export default class LoginTimeout extends Vue {
    icon: any = require("../../assets/images/ic_fetal.png");
    msg: string = formatMessage({id:"message.common.loginTimeout"});

    mounted() {
      
    }
}
